import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-900">
            <i className="ri-question-line text-accent-600"></i>
            常见问题
          </span>
          <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
            阅读前，你可能想问这些
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            关于收费、搜索、追更、缓存与更新的常见疑问，这里为你一一解答。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-200 bg-background-100" : "border-background-200/70 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-50">
                      {i + 1}
                    </span>
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "rotate-45 text-primary-600" : ""
                    }`}
                  >
                    <i className="ri-add-line text-xl"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}